import { AuthToken } from "@core/interface/common/auth-token";

export const isTokenValid = (credential: AuthToken) => {
  if (!!credential && credential.accessToken && credential.expiry_time && credential.expiry_time >= Date.now()) {
    return true;
  }
  return false;
}
